import React from 'react';
import NavBar from '../NavBar';
import Footer from '../Footer';
import '../../../styles/LegalPages.css';

const Disclaimer = () => {
  return (
    <div className="legal-page">
      <NavBar />

      <main className="legal-container">
        <section className="legal-hero">
          <span className="legal-badge">DISCLAIMER</span>

          <h1>
            Website <span>Disclaimer</span>
          </h1>

          <p>
            Informasi penting mengenai penggunaan website DEFilms.
          </p>
        </section>

        <section className="legal-content">

          <div className="legal-section">
            <h2>1. General Information</h2>

            <p>
              Welcome to <strong>DEFilms</strong>. This website is available at
              <strong> https://defilms.online/</strong> and provides information,
              references, and entertainment-related content about movies and
              TV series.
            </p>

            <p>
              The information provided on DEFilms is intended for general
              informational and entertainment purposes only.
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Movie Information</h2>

            <p>
              DEFilms may display information such as movie titles, release
              dates, genres, cast information, ratings, posters, images,
              descriptions, and other related metadata.
            </p>

            <p>
              Some of this information may be obtained from third-party data
              providers or external services.
            </p>

            <p>
              Although we make reasonable efforts to keep the information
              accurate and updated, DEFilms does not guarantee that all
              information is complete, accurate, or error-free.
            </p>
          </div>

          <div className="legal-section">
            <h2>3. Copyright</h2>

            <p>
              All movie titles, characters, logos, posters, images, videos,
              trademarks, and other copyrighted materials belong to their
              respective owners and copyright holders.
            </p>

            <p>
              DEFilms does not claim ownership of copyrighted materials that
              belong to third parties.
            </p>
          </div>

          <div className="legal-section">
            <h2>4. Third-Party Services</h2>

            <p>
              DEFilms may use third-party services, APIs, embedded content,
              external links, or other external resources to provide certain
              information and features.
            </p>

            <p>
              DEFilms does not control the content, availability, policies,
              security, or practices of third-party services.
            </p>

            <p>
              Users are responsible for reviewing the terms and policies of
              third-party services they access.
            </p>
          </div>

          <div className="legal-section">
            <h2>5. External Links</h2>

            <p>
              This website may contain links to external websites or services.
              These websites are operated independently from DEFilms.
            </p>

            <p>
              DEFilms is not responsible for the content, privacy policies,
              security, availability, or practices of external websites.
            </p>
          </div>

          <div className="legal-section">
            <h2>6. User Responsibility</h2>

            <p>
              Users are responsible for their own use of the DEFilms website
              and any third-party services accessed through it.
            </p>

            <p>
              Users must ensure that their activities comply with applicable
              laws and regulations.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. No Guarantee</h2>

            <p>
              DEFilms makes reasonable efforts to maintain the website and its
              information. However, we do not guarantee that the website will
              always be available, uninterrupted, secure, or free from errors.
            </p>
          </div>

          <div className="legal-section">
            <h2>8. Changes to This Disclaimer</h2>

            <p>
              DEFilms reserves the right to update or modify this Disclaimer
              at any time without prior notice.
            </p>

            <p>
              Any changes will become effective once they are published on
              this page.
            </p>
          </div>

          <div className="legal-section">
            <h2>9. Acceptance</h2>

            <p>
              By accessing and using DEFilms, you acknowledge that you have
              read, understood, and agreed to this Disclaimer.
            </p>
          </div>

          <div className="legal-contact-card">
            <h3>Questions?</h3>

            <p>
              If you have any questions regarding this Disclaimer, please
              contact the DEFilms team.
            </p>

            <a href="/contact">Contact Us</a>
          </div>

        </section>

        <div className="legal-updated">
          Last updated: September 21, 2026
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Disclaimer;